'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var index = require('../index-448c776e.js');
var index$1 = require('../index-63663506.js');
var index$4 = require('../index-814ab386.js');
var styled = require('styled-components');
var lightThemeColors = require('@prisjakt/design-tokens/light-theme-colors');
var index$2 = require('../index-5c01eb62.js');
var index$3 = require('../index-8844a274.js');
var definitions = require('../definitions-4ae1604d.js');
var hooks = require('../hooks-11aa6f97.js');
require('../lib-75591456.js');
require('../style-inject.es-71b52b81.js');
require('@prisjakt/design-tokens/measurements');
require('../utils-eb39d0ac.js');
require('../env-100217af.js');
require('../icon-e3ab87ed.js');
require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Card = styled__default["default"](index$1.Card).withConfig({ displayName: "Card", componentId: "-1nefy4x" })(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  background: ", ";\n  width: ", ";\n  box-shadow: ", ";\n\n  @media ", " {\n    max-width: 95vw;\n  }\n"], ["\n  background: ", ";\n  width: ", ";\n  box-shadow: ", ";\n\n  @media ", " {\n    max-width: 95vw;\n  }\n"])), function (p) { var _a; return ((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.base0) || lightThemeColors.base0; }, function (p) { return (p.$width ? "".concat(p.$width, "px") : 'auto'); }, function (p) { return definitions.shadows[p.$elevation]; }, definitions.breakpoints.smallOnly);
var Hideable = styled__default["default"](index$2.Hideable).withConfig({ displayName: "Hideable", componentId: "-7knch1" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  && {\n    z-index: ", ";\n    flex: 0;\n  }\n"], ["\n  && {\n    z-index: ", ";\n    flex: 0;\n  }\n"])), function (p) { return p.$zIndex; });
var CloseButton = styled__default["default"](index$3.Clickable).withConfig({ displayName: "CloseButton", componentId: "-1vfp62k" })(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  && {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n  }\n"], ["\n  && {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;

var Popover = function (props) {
    var _a = props.visible, visible = _a === void 0 ? false : _a, _b = props.zIndex, zIndex = _b === void 0 ? 4 : _b;
    return (React__default["default"].createElement(Hideable, { visible: visible, "$zIndex": zIndex },
        React__default["default"].createElement(PopoverContent, tslib.__assign({}, props))));
};
function PopoverContent(props) {
    var id = props.id, children = props.children, className = props.className, containerProps = props.containerProps, onClose = props.onClose, _a = props.elevation, elevation = _a === void 0 ? definitions.Elevation.MEDIUM : _a, _b = props.horizontalAlign, horizontalAlign = _b === void 0 ? index.Alignment.Start : _b, _c = props.verticalAlign, verticalAlign = _c === void 0 ? index.Alignment.EndOutside : _c, _d = props.offsetX, offsetX = _d === void 0 ? 0 : _d, _e = props.offsetY, offsetY = _e === void 0 ? 0 : _e, width = props.width, paddingRem = props.paddingRem, _f = props.zIndex, zIndex = _f === void 0 ? 10 : _f;
    var _g = React.useState(offsetX), adjustedOffset = _g[0], setAdjustedOffset = _g[1];
    var _h = React.useState(horizontalAlign), adjustedAlignment = _h[0], setAdjustedAlignment = _h[1];
    var ref = hooks.useOnClickOutside(function (e) {
        var toggleElement = document.querySelector("[aria-describedby=\"".concat(id, "\"]"));
        // Only close Popover when clicking outside or not clicking the toggle element paired
        // with the Popover using the same `id`
        if (e.type !== 'click' ||
            !toggleElement ||
            !toggleElement.contains(e === null || e === void 0 ? void 0 : e.target)) {
            onClose(e);
        }
    });
    // When opened, check if the Popover is overflowing the viewport
    // and adjust its horizontal offset to fit the viewport
    React.useEffect(function () {
        var _a, _b;
        var widthMin = 0;
        var widthMax = window.innerWidth;
        var positionMax = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().right) || 0;
        var positionMin = ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().left) || 0;
        // Overflowing the left side
        if (positionMin < widthMin) {
            if (adjustedAlignment === index.Alignment.Center) {
                // Chanage alignment from center to left because center + offsetX doesn't work together
                setAdjustedAlignment(index.Alignment.StartOutside);
            }
            else {
                // Move Popover to the left edge
                setAdjustedOffset(widthMin - positionMin + offsetX);
            }
        }
        // Overflowing the right side
        if (positionMax > widthMax) {
            if (adjustedAlignment === index.Alignment.Center) {
                // Chanage alignment from center to left because center + offsetX doesn't work together
                setAdjustedAlignment(index.Alignment.EndOutside);
            }
            else {
                // Move Popover to the right edge
                setAdjustedOffset(widthMax - positionMax + offsetX);
            }
        }
        // Position within the boundaries
        if (positionMax < widthMax && positionMin > widthMin) {
            setAdjustedOffset(offsetX);
        }
    }, [horizontalAlign, offsetX, adjustedAlignment, ref]);
    return (React__default["default"].createElement(index.Floater, { containerProps: tslib.__assign(tslib.__assign({}, containerProps), { ref: ref, id: id }), className: className, positioning: index.Positioning.Absolute, horizontalAlign: adjustedAlignment, verticalAlign: verticalAlign, offsetX: adjustedOffset, offsetY: offsetY, offsetUnit: definitions.LengthUnit.Pixels, zIndex: zIndex },
        React__default["default"].createElement(Card, { "$width": width, "$elevation": elevation, paddingRem: paddingRem },
            React__default["default"].createElement(index$1.CardContent, null, children),
            React__default["default"].createElement(CloseButton, { onClick: onClose },
                React__default["default"].createElement(index$4.IconClose, { size: 16 })))));
}

Object.defineProperty(exports, 'Alignment', {
    enumerable: true,
    get: function () { return index.Alignment; }
});
exports.Popover = Popover;
//# sourceMappingURL=index.js.map
